/**
 * WordPress dependencies
 */
/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * Internal dependencies
 */
import './style.scss';
import { Header } from './header';
import { FooterActions } from './footer-actions';

import { Summary } from './summary';
import { Description } from '../../../results/components/sidebar/description';
import { KindSelector } from '../kind-selector';
import { Export } from './export';
import { Advanced } from './advanced';
import { ErrorMessage } from './error-message';
import { ParticipationConditions } from './participation-conditions';
import { NoQuotaWarning } from './no-quota-warning';

export type SidebarProps = {
	readonly className?: string;
};

export const Sidebar = ( { className }: SidebarProps ): JSX.Element => {
	return (
		<div className={ clsx( [ 'nab-heatmap-results-sidebar', className ] ) }>
			<Header />
			<NoQuotaWarning />

			<div className="nab-heatmap-results-sidebar__wrapper">
				<KindSelector />
				<Summary />
				<Description />
				<ParticipationConditions />
				<Export />
				<Advanced />
			</div>

			<ErrorMessage />
			<FooterActions />
		</div>
	);
};
